module.exports = __webpack_public_path__ + "static/media/muji ui5.6352e029.png";